// !only for class list
export const GET_CLASSES_LIST_REQUEST = 'GET_CLASSES_LIST_REQUEST';
export const GET_CLASSES_LIST_SUCCESS = 'GET_CLASSES_LIST_SUCCESS';
export const GET_CLASSES_LIST_FAILED = 'GET_CLASSES_LIST_FAILED';

// !student info for the classes
export const GET_CLASS_STUDENT_INFO_REQUEST = 'GET_CLASS_STUDENT_INFO_REQUEST';
export const GET_CLASS_STUDENT_INFO_SUCCESS = 'GET_CLASS_STUDENT_INFO_SUCCESS';
export const GET_CLASS_STUDENT_INFO_FAILED = 'GET_CLASS_STUDENT_INFO_FAILED';
